module.exports = __webpack_public_path__ + "img/11.7ed1c361.png";